const fetchThumbnail = async (videoId, source) => {
  // if the video is a user uploaded video,
  // extract the first frame of the video and use it as the thumbnail
  if (source === 'html5' && typeof window !== 'undefined') {
    return new Promise((resolve, reject) => {
      const video = window.document.createElement('video');

      video.src = videoId;
      video.muted = true;
      video.playsInline = true;
      video.crossOrigin = 'anonymous';

      video.addEventListener('loadeddata', () => {
        video.currentTime = Math.min(1, video.duration || 0);
      });

      video.addEventListener('seeked', () => {
        const canvas = window.document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject(new Error('Could not get canvas context'));
          return;
        }

        ctx.drawImage(video, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      });

      video.addEventListener('error', reject);
    });
  }

  const formattedId = videoId.split('?')[0];

  return source === 'youtube'
    ? `https://img.youtube.com/vi/${formattedId}/hqdefault.jpg`
    : `https://vumbnail.com/${formattedId}.jpg`;
};

export default fetchThumbnail;
